import { visionTypes } from "../components/vision-option"
export const getVisionType = (value, type) => value === visionTypes[type]
